import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import styles from "./WhoItIsFor.module.css";

const roles = [
  {
    id: "1",
    image: "/creator-athlete.jpg",
    heading: "Athletes",
    text: "Celebrate your victories and unforgettable plays by turning them into digital memories your fans can collect and support you with."
  },
  {
    id: "2",
    image: "/creator-artist.jpg",
    heading: "Artists",
    text: "Transform your artwork, performances, and creative milestones into signed digital collectibles shared across social media."
  },
  {
    id: "3",
    image: "/creator-influencer.jpg",
    heading: "Influencers",
    text: "Capture your biggest online moments and give your followers the chance to own part of your story — directly from your posts."
  }
];

const WhoItIsFor = ({ className = "" }) => {
  return (
    <section className={[styles.whoItIsForSection, className].join(" ")}>
      <Typography className={styles.sectionTitle} component="h1">
        Built for creators who inspire others
      </Typography>
      <Typography className={styles.sectionSubtitle} component="p">
        Whether you’re an athlete, artist, or influencer — MementoMaster helps you
        turn your most powerful moments into collectible memories.
      </Typography>
      <Box className={styles.rolesGrid}>
        {roles.map(role => (
          <Box key={role.id} className={styles.roleCard}>
            <img src={role.image} alt={role.heading} className={styles.roleImage} />
            <Typography className={styles.roleHeading}>{role.heading}</Typography>
            <Typography className={styles.roleText}>{role.text}</Typography>
          </Box>
        ))}
      </Box>
    </section>
  );
};

WhoItIsFor.propTypes = {
  className: PropTypes.string,
};

export default WhoItIsFor;